export default __webpack_public_path__ + "static/media/logo_spwn_black.38641f84.svg";